import {
	ready
} from '~/core'
ready('slider', '.slider', (slider) => {
	const $timing = 400 // $timing in this file must also match $timing in _slider.scss
	const $autoTime = 5000 // change $autoTime to make the time inbetween automatic slides longer or shorter, set to 0 to disable
	//check if slider has autoslide class applied
	const doAuto = slider.classList.contains('slider--autoSlide')
	//check if slides have title data attribute to do titles
	const doTitles = slider.querySelector('.slider-slide').dataset.title;
	const slideContainer = slider.querySelector('.slider-slides')
	const slides = [...slideContainer.querySelectorAll('.slider-slide')]
	const navContainer = slider.querySelector('.slider-nav')
	const dotContainer = slider.querySelector('.slider-bulletNav')
	let navs = [],
		dots = [],
		titles = []
	let total, active, next, prev, dir, timer
	const date = new Date();
	const month = date.getMonth() + 1;

	let monthIndex = slides.findIndex((el) => { return el.dataset.month == month });
	if (monthIndex < 0) monthIndex = 0;

	const dotClick = (dot) => {
		if (!slider.classList.contains('is-changing')) {
			if (doAuto) clearInterval(timer)

			next = dots.indexOf(dot)
			dir = next > active ? 'next' : next < active ? 'prev' : dir
			slide(true)
		}
	}

	const createDots = () => {
		slides.forEach((slide, i) => {
			let dot = `<div class="slider-bullet" ${i + 1 == 1 ? `data-current="${i + 1}"` : ''}>${i + 1}</div>`
			dotContainer.insertAdjacentHTML('beforeend', dot)
		})
		dots = [...dotContainer.querySelectorAll('.slider-bullet')]
		dots[monthIndex].classList.add('is-active')
		dots.forEach(dot => dot.addEventListener('click', () => dotClick(dot)))
		dots.forEach(dot => dot.addEventListener('keydown', (e) => e.code == 'Enter' ? dotClick(dot) : false))
	}


	const createTitles = () => {
		let titleContainer = document.createElement('ul')
		titleContainer.classList.add('slider-titles')
		navContainer.insertBefore(titleContainer, navContainer.lastChild)

		slides.forEach(slide => {
			titles.push(slide.dataset.title);
		})
		titles.forEach(title => {
			let titleItem = document.createElement('li')
			titleItem.classList.add('slider-titleItem')
			titleItem.innerHTML = `${title}`
			titleContainer.append(titleItem)
		})
		titles = [...titleContainer.querySelectorAll('.slider-titleItem')]
		titles[monthIndex].classList.add('is-active')
	}

	const navClick = (nav) => {
		if (!slider.classList.contains('is-changing')) {
			if (doAuto) clearInterval(timer)
			if (nav.classList.contains('slider-navBtn--next')) {
				dir = 'next'
				next = active < total ? active + 1 : 0
			} else {
				dir = 'prev'
				next = active > 0 ? active - 1 : total
			}
			slide(true)
		}
	}

	const createNavs = () => {
		let nav = `<button class="slider-navBtn slider-navBtn--prev" aria-label="Previous Month"><span class='slider-navBtnText'>Previous Month</span></button><button class="slider-navBtn slider-navBtn--next" aria-label="Next Month"><span class='slider-navBtnText'>Next Month</span></button>`
		navContainer.insertAdjacentHTML('beforeend', nav)
		navs = [...navContainer.querySelectorAll('.slider-navBtn')]
		navs.forEach(nav => nav.addEventListener('click', () => navClick(nav)))
		navs.forEach(nav => nav.addEventListener('keydown', (e) => e.code == 'Enter' ? navClick(nav) : false))
	}

	const slideFocus = function (e) {
		slideContainer.scrollLeft = 0;
		setTimeout(() => {
			slideContainer.scrollLeft = 0
		}, 0)
		if (!slider.classList.contains('is-changing')) {
			if (doAuto) clearInterval(timer)
			dir = 'next'
			next = slides.indexOf(this)
			if (active !== next) slide(true)
		}
	}

	const setTimer = () => {
		timer = setInterval(() => {
			dir = 'next'
			next = active < total ? active + 1 : 0
			slide()
		}, $autoTime)
	}

	const slide = (click = false) => {
		slider.classList.add('is-changing')
		slides.forEach(slide => slide.classList.remove('is-initial'))
		slides[active].classList.add(`is-leaving--${dir}`)
		slides[active].classList.add('is-leaving')
		slides[active].classList.remove('is-active')
		slides[active].classList.remove('is-active--next')
		slides[active].classList.remove('is-active--prev')
		slides[next].classList.add(`is-active--${dir}`)
		slides[next].classList.add('is-active')

		if (dotContainer) {
			dots[active].classList.remove('is-active')
			dots[next].classList.add('is-active')
			dots[monthIndex].setAttribute('data-current', next + 1)
		}
		if (doTitles) {
			titles[active].classList.remove('is-active')
			titles[next].classList.add('is-active')
		}

		prev = active
		active = next

		slides[next].classList.remove('is-active--next')
		slides[next].classList.remove('is-active--prev')

		setTimeout(() => {
			slides[prev].classList.remove('is-leaving')
			slides[prev].classList.remove('is-leaving--next')
			slides[prev].classList.remove('is-leaving--prev')
			navs.forEach(nav => nav.classList.remove('is-inactive'))
			dots.forEach(dot => dot.classList.remove('is-inactive'))
			slider.classList.remove('is-changing')
			if (click && doAuto) setTimer()
		}, $timing * 2)
	}

	const init = () => {
		total = slides.length - 1
		active = monthIndex
		if (total) {
			if (dotContainer) createDots()
			if (navContainer) createNavs()
			if (doAuto) setTimer()
			if (navContainer && doTitles) createTitles()
		}

		slides[monthIndex].classList.add('is-active')
		slides[monthIndex].classList.add('is-initial')
		slides.forEach(slide => slide.addEventListener('focusin', slideFocus))
	}

	init()
})